import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
const index= ()=>import ('@/views/index/index');
const layout= ()=>import ('@/views/layout');
const usercenter= ()=>import ('@/views/usercenter/index');
const userpower= ()=>import ('@/views/usercenter/userpower');
const visitorlog= ()=>import ('@/views/usercenter/visitorlogs');
const downloadlog= ()=>import ('@/views/usercenter/downloadlogs');
const mytoken= ()=>import ('@/views/usercenter/mytoken');
const handbook= ()=>import ('@/views/handbook/index');
const apisummarize= ()=>import ('@/views/handbook/apisummarize');
const apiDemo= ()=>import ('@/views/handbook/apiDemo');
const instruction= ()=>import ('@/views/handbook/instruction');
const faq= ()=>import ('@/views/handbook/FAQ');
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: layout,
      children:[
        {
        path: '/',
        name: 'webIndex',
        component: index,
        },
        {
          path:'/user',
          name: 'userCenter',
          component: usercenter,
          children:[
            {
              path:'/user/power',
              name: 'userPower',
              component: userpower
            },
            {
              path:'/user/visitorlog',
              name: 'visitorLog',
              component: visitorlog
            } ,
            {
              path:'/user/downloadlog',
              name: 'downloadLog',
              component: downloadlog
            },
            {
              path:'/user/mytoken',
              name: 'myToken',
              component: mytoken
            }
          ]
        },
        {
          path:'/handbook',
          name: 'handBook',
          component: handbook,
          children:[
            {
              path:'/handbook/summarize',
              name: 'apiSummarize',
              component: apisummarize
            },
            {
              path:'/handbook/netdemo',
              name: 'netDemo',
              // component: netdome,
              component: apiDemo,
              props: {
                title: 'C#应用示例',
                sdkLink: 'static/apidemo/net/SCI99QuantAPI_CSharp.dll',
                demoLink: 'static/apidemo/net/SCI99QuantAPI_CSharpDemo.zip',
                mdPath: 'static/apidemo/net/netdemo.txt'
              }
            }
            ,
            {
              path:'/handbook/javademo',
              name: 'javaDemo',
              // component: javadome
              component: apiDemo,
              props: {
                title: 'Java应用示例',
                sdkLink: 'static/apidemo/JAVA/quant_api_java-2.0.4.jar',
                demoLink: 'static/apidemo/JAVA/java_demo.zip',
                mdPath: 'static/apidemo/JAVA/javademo.txt'
              }
            },
            {
              path:'/handbook/pythondemo',
              name: 'pythonDemo',
              // component: pythondome
              component: apiDemo,
              props: {
                title: 'Python应用示例',
                sdkLink: 'static/apidemo/python/quant_api_sdk.zip',
                demoLink: 'static/apidemo/python/python_demo.zip',
                mdPath: 'static/apidemo/python/pythondemo.txt'
              }
            },
            {
              path:'/handbook/getToken',//获取token页面
              name: 'getToken',
              component: instruction
            },
            {
              path:'/handbook/dataItemInventoryInterface',//数据清单接口页面
              name: 'dataItemInventoryInterface',
              component: instruction
            },
            {
              path:'/handbook/dataFrequencyInterface',//数据变频接口页面
              name: 'dataFrequencyInterface',
              component: instruction
            },
            {
              path:'/handbook/dataiteminterface',//数据项接口页面
              name: 'dataiteminterface',
              component: instruction
            },
            {
              path:'/handbook/pdataiteminterface',//预测数据项接口页面
              name: 'pdataiteminterface',
              component: instruction
            },
            {
              path:'/handbook/edataiteminterface',//企业数据项接口页面
              name: 'edataiteminterface',
              component: instruction
            },
            {
              path:'/handbook/apifaq',
              name: 'apiFAQ',
              component: faq
            }
          ]
        }
        ]
    }
  ]
})
